import { useReq } from "@larner.dev/use-req";
import { Box, Heading, Text } from "@chakra-ui/react";
import { Meta } from "../../../components/Meta/Meta";
import { cmsRequest } from "../../../lib/cmsHelpers";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { LoaderScreen } from "../../../components/LoaderScreen/LoaderScreen";
import { CMSDataList, Policy as PolicyAttributes } from "@greenflagdate/shared";
import { NotFound } from "../../../components/NotFound/NotFound";
import dayjs from "dayjs";
import { StandardMarkdown } from "../../../components/StandardMarkdown/StandardMarkdown";

export function Policy() {
  const { slug } = useParams();
  const [request, requestState] =
    useReq<CMSDataList<PolicyAttributes>>(cmsRequest);
  useEffect(() => {
    request.get(`/api/policies?filters[slug][$eq]=${slug}`);
  }, [slug, request]);

  if (requestState.loading) {
    return <LoaderScreen />;
  }
  if (requestState.error || !requestState.result?.data.length) {
    return <NotFound />;
  }

  const [policy] = requestState.result.data;

  return (
    <Box marginX="auto" maxWidth="32rem" paddingX="2rem" paddingBottom="2rem">
      <Meta>
        <title>{policy.attributes.title} - Green Flag</title>
      </Meta>
      <Heading as="h1" textStyle="headingLg" textAlign="center" paddingY="2rem">
        {policy.attributes.title}
      </Heading>
      <Text textStyle="bodyMuted">
        Last Updated {dayjs(policy.attributes.createdAt).format("LL")}
      </Text>
      <StandardMarkdown content={policy.attributes.content} headingAnchors />
    </Box>
  );
}
